import './styles/maintenance-item.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import classnames from 'classnames'
import moment     from 'moment'

import DeleteMaintenanceButton from './DeleteMaintenanceButton'

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
const timeOffsetLabel = `Local Time (${timezone}, UTC/GMT ${-new Date().getTimezoneOffset() / 60})`

function formatTime(timestamp) {
  return moment(timestamp).format('YYYY-MM-DD h:mm:ss A')
}

function getMaitenanceDuration(startTimeMilliseconds, endTimeMilliseconds, expired) {
  const duration = moment.duration(endTimeMilliseconds - startTimeMilliseconds).humanize()

  return expired
    ? `expired ${duration} ago`
    : `${duration} remaining`
}


export default class MaintenanceItem extends React.Component {
  static propTypes = {
    item:    PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  renderHighlight = (title, message) => {
    const className = classnames('item-highlight ui mini message')

    return (
      <div className={className}>
        <div className="title">{ title }</div>
        <div className="message">{ message }</div>        
      </div>
    )
  }

  render() {
    const { item } = this.props

    const showTimeRange = item.startTime && item.endTime

    const startTime = item.startTime && formatTime(item.startTime)
    const endTime   = item.endTime && formatTime(item.endTime)

    const startTimeMilliseconds = startTime && new Date(startTime).getTime()
    const endTimeMilliseconds   = endTime && new Date(endTime).getTime()
    const expired               = endTimeMilliseconds && endTimeMilliseconds < new Date().getTime()

    const duration  = endTime
      && getMaitenanceDuration(startTimeMilliseconds, endTimeMilliseconds, expired)

    const className = classnames('maintenance-item', { expired })
  
    return (
      <div className={className}>
        <div className="header">
          <div className="name">{ item.name }</div>
          { item.description && <div className="description">{ `(${item.description})` }</div> }
        </div>

        { showTimeRange && (
            <div className="time-range-container">
              <div className="time-range">
                { this.renderHighlight('Start', startTime ) }
                { duration && (
                  <div className="line">
                    <div>{duration}</div>
                  </div>
                )}
                { this.renderHighlight('End',   endTime ) }
              </div>
              <div className="timezone-tip">{timeOffsetLabel}</div>
            </div>
        )}

        <div className="actions">
          <div className="action-container">
            <DeleteMaintenanceButton maintenance={item} />
          </div>
        </div>
      </div>
    )
  }
}